// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "Another example our Crime Data API in action, this time visualising figures in proportional terms.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Crime treemap",
  id: "crime-treemap",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Crime", "Data viz", "Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/crime-treemap/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "CrimeTreemapConfigTool" */ "app/components/tools/CrimeTreemapConfigTool/CrimeTreemapConfigTool"),
    loading: DynamicImportLoader,
    modules: ["CrimeTreemapConfigTool"]
  })
};

export default CONFIG;
